import { render } from "./help-actions-videos.vue?vue&type=template&id=e6bf00b4"
import script from "./help-actions-videos.vue?vue&type=script&lang=js"
export * from "./help-actions-videos.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__